import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicRenderSharedModule } from '../shared/shared.module';

import { PageResolverModule } from './resolver/page-resolver.module';
import { DynamicPageComponent } from './dynamic-page/dynamic-page.component';
import { PageSharedModule } from './shared/page-shared.module';
import { CoreCustomPagesModule } from './custom-pages/core-custom-pages.module';
import { CardModule } from '../card/card.module';

@NgModule({
  declarations: [DynamicPageComponent],
  exports: [DynamicPageComponent, CoreCustomPagesModule, CardModule],
  imports: [CommonModule, CoreCustomPagesModule, PageSharedModule, PageResolverModule, DynamicRenderSharedModule]
})
export class PageModule {}
